@import 'styles/variables';
@import 'styles/mixins';

.option {
  align-items: center;
  background-color: var(--neutral-5);
  border: 1px solid var(--neutral-5);
  border-radius: 6px;
  display: flex;
  gap: 16px;
  padding: 8px;

  &:hover {
    background: linear-gradient(0deg, var(--neutral-5), var(--neutral-5)), var(--neutral-10);
    cursor: pointer;

    .optionTitle {
      color: white !important;
    }

    .optionSubtitle {
      color: white !important;
    }
  }

  .left {
    border-radius: 4px;
    height: 100%;
    width: 160px;

    &.mobile {
      height: 96px;
      width: 96px;
    }

    &.blue {
      background: linear-gradient(90deg, #286ee1 0%, #26d84d 100%);

      &.mobile {
        padding: 32px;
      }
    }

    &.purple {
      background: linear-gradient(90deg, #a967eb 0%, #4659ff 95%);
      padding: 28px;
      min-width: 160px;

      &.mobile {
        align-items: center;
        display: flex;
        justify-content: center;
        padding: 16px;
        min-width: unset;
      }
    }
  }

  .right {
    color: $grey-90;
    max-width: 216px;
    text-align: left;

    .optionTitle {
      @include lg-semibold;

      color: var(--neutral-50);
      margin-bottom: 4px;
    }

    .optionSubtitle {
      color: var(--neutral-50);
      @include md-regular;
    }
  }
}
